import { request } from "@frontend/lib/http";

import type { ContactOption } from "../types";

type RequestOptions = {
  signal?: AbortSignal;
};

export type ContactApi = {
  fetchContacts(options?: RequestOptions): Promise<ContactOption[]>;
};

export const contactApi: ContactApi = {
  fetchContacts(options) {
    return request({ route: "api_contacts_list", ...options });
  },
};
